import { createIcon } from '../createIcon';
import { ReactComponent as IconFilter } from '../svg/filter.svg';

export default createIcon(IconFilter);
